import { LinkTo } from '@ember/routing';
import Component from '@glimmer/component';
import { VStack } from 'tio-ui/components/layout';
import {
  PhChartBar,
  PhUsers,
  PhBrain,
  PhUsersFour,
  PhTrendUp,
  PhArrowLeft,
} from 'ember-phosphor-icons';

export default class CareerPathwaysAdminRoute extends Component {
  <template>
    {{! template-lint-disable no-bare-strings }}
    <VStack class="w-full min-w-0">
      {{! Admin Navigation }}
      <div
        class="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700 -mx-4 -mt-4 px-4 mb-6"
      >
        <div class="flex items-center justify-between py-3">
          <LinkTo
            @route="authenticated.reimagined"
            class="flex items-center gap-2 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
          >
            <PhArrowLeft @size={{18}} />
            <span class="text-sm">Back to Employee View</span>
          </LinkTo>

        </div>
        <nav class="flex gap-1 overflow-x-auto">
          <LinkTo
            @route="authenticated.reimagined.admin.index"
            class="px-4 py-3 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-violet-600 dark:hover:text-violet-400 border-b-2 border-transparent hover:border-violet-300 dark:hover:border-violet-600 transition-colors flex items-center gap-2 whitespace-nowrap"
            @activeClass="!text-violet-600 dark:!text-violet-400 !border-violet-600"
          >
            <PhChartBar @size={{18}} />
            Overview
          </LinkTo>
          <LinkTo
            @route="authenticated.reimagined.admin.team"
            class="px-4 py-3 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-violet-600 dark:hover:text-violet-400 border-b-2 border-transparent hover:border-violet-300 dark:hover:border-violet-600 transition-colors flex items-center gap-2 whitespace-nowrap"
            @activeClass="!text-violet-600 dark:!text-violet-400 !border-violet-600"
          >
            <PhUsers @size={{18}} />
            Team View
          </LinkTo>
          <LinkTo
            @route="authenticated.reimagined.admin.skills-inventory"
            class="px-4 py-3 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-violet-600 dark:hover:text-violet-400 border-b-2 border-transparent hover:border-violet-300 dark:hover:border-violet-600 transition-colors flex items-center gap-2 whitespace-nowrap"
            @activeClass="!text-violet-600 dark:!text-violet-400 !border-violet-600"
          >
            <PhBrain @size={{18}} />
            Skills Inventory
          </LinkTo>
          <LinkTo
            @route="authenticated.reimagined.admin.leadership"
            class="px-4 py-3 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-violet-600 dark:hover:text-violet-400 border-b-2 border-transparent hover:border-violet-300 dark:hover:border-violet-600 transition-colors flex items-center gap-2 whitespace-nowrap"
            @activeClass="!text-violet-600 dark:!text-violet-400 !border-violet-600"
          >
            <PhUsersFour @size={{18}} />
            Leadership
          </LinkTo>
          <LinkTo
            @route="authenticated.reimagined.admin.program-effectiveness"
            class="px-4 py-3 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-violet-600 dark:hover:text-violet-400 border-b-2 border-transparent hover:border-violet-300 dark:hover:border-violet-600 transition-colors flex items-center gap-2 whitespace-nowrap"
            @activeClass="!text-violet-600 dark:!text-violet-400 !border-violet-600"
          >
            <PhTrendUp @size={{18}} />
            Program ROI
          </LinkTo>
        </nav>
      </div>

      {{outlet}}
    </VStack>
  </template>
}
